import React, { useState, useEffect } from 'react'

import { Accordion, Popup, Icon, Grid, Menu } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import _ from 'lodash'

import './Sidebar.scss'
import styles from './../../styles/global.module.scss'

function getWindowDimensions() {
	const { innerWidth: width, innerHeight: height } = window
	return {
		width,
		height,
	}
}

const ClientSidebarMenu = (props) => {
	const { expand, setExpand, client, location, mobileOnly, setMobileOnly } =
		props

	const [windowDimensions, setWindowDimensions] = useState(
		getWindowDimensions()
	)
	const [isActive, setIsActive] = useState(false)
	const [isSubActive, setIsSubActive] = useState(false)

	useEffect(() => {
		function handleResize() {
			if (windowDimensions !== getWindowDimensions())
				setWindowDimensions(getWindowDimensions())
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	useEffect(() => {
		if (windowDimensions.width <= 425) {
			setMobileOnly(true)
			if (expand === 2 || expand == null) setExpand(1)
		} else {
			setMobileOnly(false)
		}
	}, [windowDimensions])

	useEffect(() => {
		if (location) {
			!mobileOnly ? setExpand(0) : setExpand(1)
		}
	}, [location])

	return (
		<>
			<div
				className='sidebar'
				style={
					expand == null || expand == 2
						? { width: '250px' }
						: expand == 1
						? { width: '55px' }
						: null
				}
			>
				<Accordion
					key={`accordion-menu-sidebar`}
					fluid
					style={{ paddingLeft: '12px', paddingBottom: '5px' }}
				>
					<Accordion.Title
						key={`title-sidebar`}
						active={isActive}
						onClick={(e) => {
							e.preventDefault()
							e.stopPropagation()
							setIsActive(!isActive)
						}}
					>
						<Popup
							trigger={
								<Menu.Item
									className={`${styles.shrinkOnHover} SubMenu__Item`}
									style={{ width: '100%', display: 'inline-block' }}
								>
									<Icon
										name='qrcode'
										size='large'
										className='SideBar__Outline'
									/>
									{(expand == null || expand == 2) && (
										<h5 className='menu-row-title'> Escanéos QR </h5>
									)}
								</Menu.Item>
							}
							positionFixed
							position='right center'
							pinned
							hoverable
							closeOnTriggerClick={true}
							offset={[0, 0]}
							className='SubMenu__Content'
							content={
								<Grid divided='vertically' style={{ width: '15rem' }}>
									<Grid.Row style={{ paddingBottom: 0 }}>
										<Grid.Column>
											<h4>Escanéos QR</h4>
										</Grid.Column>
									</Grid.Row>
									<Grid.Row style={{ paddingTop: '0', paddingBottom: '0' }}>
										<Grid.Column>
											<Accordion.Content
												key={`content-escanéos_qr`}
												style={{ marginTop: '0px', paddingTop: '0px' }}
												active={isActive}
											>
												<Menu
													vertical
													fluid
													text
													style={{ paddingLeft: '30px' }}
												>
													<Link
														key={`link-escanéos_qr`}
														to={`/client/company_qr_scanning`}
														className='sub_menu_row'
													>
														<Menu.Item
															className={styles.growOnHover}
															style={{ margin: '0' }}
														>
															Escanéos QR de la Compañía
														</Menu.Item>
													</Link>
												</Menu>
											</Accordion.Content>
										</Grid.Column>
									</Grid.Row>
								</Grid>
							}
						/>
					</Accordion.Title>
				</Accordion>
			</div>
		</>
	)
}

export default ClientSidebarMenu
